<template>
  <v-card class="pa-2">
    <div class="d-flex justify-space-between flex-wrap">
      <v-row dense class="ma-0" align="center" style>
        <v-col cols="12" sm="5" style="min-width: 222px">
          <label class="label">Nome</label>
          <v-text-field
            v-model="filterListFolderWithDoc.name"
            class="primary-input"
            outlined
            hide-details="auto"
            placeholder="Pesquisar por Nome"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" style="margin-top: auto">
          <v-btn class="primary-button ma-1 mb-4" depressed @click="loadData">
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
      <div style="margin-top: 18px; align-content: center">
        <v-btn
          class="primary-button ma-1 mb-4"
          depressed
          v-if="institution.userType < 3 || institution.userType == 8"
          @click="importToInstitution"
        >
          Importar estrutura padrão
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              class="secondary-button ma-1 mb-4"
              v-bind="attrs"
              v-on="on"
              v-if="institution.userType < 3 || institution.userType == 8"
            >
              Novo item
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item-group active-class="info--text text--accent-2">
              <v-list-item
                v-for="(item, index) in addMenuItems"
                :key="index"
                @click="item.action"
                width="100%"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn
          class="pendents-button ma-1 mb-4"
          color="#ff4f64"
          depressed
          v-if="institution.userType < 3"
          @click=";(trashModalKey = !trashModalKey), (trashModal = true)"
        >
          Lixeira
          <v-icon class="ml-2">mdi-trash-can-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="downloadList.length > 0" class="d-flex justify-end mt-4">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="mr-2 hidden-sm-and-down primary-button ma-1"
            v-bind="attrs"
            v-on="on"
            depressed
          >
            {{ $t('Selecionados') }}
          </v-btn>
        </template>
        <v-list nav dense>
          <v-list-item width="100%" @click="getZip">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('Baixar Selecionados') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item width="100%" @click="deleteSelectedItens">
            <v-list-item-icon class="mr-2">
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t('Excluir Selecionados') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="mt-6 topper-espansion">
      <p class="ma-0 topper-espansion-title">Identificação</p>
      <p class="ma-0 topper-espansion-title">Ações</p>
    </div>

    <v-expansion-panels v-model="panel">
      <DragDiv
        :list="listFolderWithDoc"
        group="items"
        ghost-class="ghost"
        animation="200"
        style="width: 100%"
        draggable=".my-list-items"
        @change="ChangeOrder"
      >
        <v-expansion-panel
          v-for="(item, i) in listFolderWithDoc"
          :key="i"
          :readonly="item.isDocument"
          class="my-list-items"
        >
          <v-expansion-panel-header
            :hide-actions="item.isDocument"
            :style="`${item.isDocument ? 'cursor: default' : ''}`"
          >
            <div
              v-if="item.isDocument"
              class="d-flex justify-center"
              style="max-width: 20px; margin-top: -6px"
            >
              <v-checkbox
                class="mr-1"
                dense
                small
                v-model="item.selected"
                hide-details
                @click="addToDownloadList(item)"
              ></v-checkbox>
            </div>
            <span
              v-if="item.isDocument"
              style="margin-bottom: -4px; margin-left: 6px"
            >
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-file-document-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <span v-else>
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-folder-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <div
              :style="`display: flex; justify-content: flex-end; ${
                item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
              }`"
            >
              <span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      dark
                      small
                      depressed
                      color="primary"
                      v-if="
                        institution.userType < 3 || institution.userType == 8
                      "
                      @click.stop="
                        item.isDocument
                          ? editDocument(item)
                          : updateFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-menu v-if="!item.isDocument" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltipOn }">
                        <v-btn
                          class="ma-1"
                          small
                          depressed
                          color="primary"
                          dark
                          v-if="
                            institution.userType < 3 ||
                            institution.userType == 8
                          "
                          v-on="{ ...on, ...tooltipOn }"
                        >
                          <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </template>
                  <v-list nav dense>
                    <v-list-item-group active-class="info--text text--accent-2">
                      <v-list-item
                        v-for="(actionItem, index) in addTableItems"
                        :key="index"
                        @click.stop="actionItem.action(item)"
                        width="100%"
                      >
                        <v-list-item-icon class="mr-2">
                          <v-icon>{{ actionItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{
                          actionItem.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>

                <v-tooltip v-if="item.isDocument" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="primary"
                      @click.stop="getFile(item)"
                    >
                      <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir documento</span>
                </v-tooltip>

                <v-tooltip v-if="item.isDocument" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.extension === 'pdf'"
                      class="ma-1"
                      :readonly="item.validated"
                      :color="item.validated ? 'secondary' : 'primary'"
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="validateDoc(item)"
                      small
                    >
                      <v-icon dark> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    item.validated ? 'Documento validado' : 'Validar documento'
                  }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="#ff4f64"
                      v-if="
                        institution.userType < 3 || institution.userType == 8
                      "
                      @click.stop="
                        item.isDocument
                          ? deleteDocument(item)
                          : deleteFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5"
                        >mdi-trash-can-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </span>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <CommonFolder
              v-if="!item.isDocument"
              :folder="item"
              @get-file="getFile"
              @validate-doc="validateDoc"
              @delete-document="deleteDocument"
              @delete-folder="deleteFolder"
              @updateSumFiles="updateSumFiles"
              @add-to-download-list="addToDownloadList"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </DragDiv>
    </v-expansion-panels>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="modal" max-width="500px">
      <ManageDocument
        :documentId="selectedDocument.id"
        :parentFolderId="selectedFolderId"
        @close="modal = false"
        @success="reloadData"
        @totalFilesUpdate="updateSumFiles"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="folderModal" max-width="500px">
      <ManageFolder
        :folderId="selectedFolderId"
        :parentFolderId="parentFolderId"
        @close="folderModal = false"
        @success="reloadData"
        :key="folderDialogKey"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja enviar este arquivo para a lixeira?
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="ma-1" color="error" text @click="confirmDelete()"
            >Excluir</v-btn
          >
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteFolderDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja enviar esta pasta para a lixeira?
          </div>

          <v-btn
            class="ma-1"
            color="grey"
            text
            @click="deleteFolderDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn class="ma-1" color="error" text @click="confirmDeleteFolder()">
            Excluir
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="trashModal" max-width="800">
      <Trash
        :key="trashModalKey"
        @recover="loadData"
        @callSumFiles="updateSumFiles"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import moment from 'moment'
import ManageDocument from './manageDocument.vue'
import ManageFolder from './manageFolder.vue'
import CommonFolder from './commonComponent/commonFolder.vue'
import Trash from './commonComponent/trash.vue'

export default {
  name: 'CommonAreaDocument',

  components: {
    Trash,
    ManageDocument,
    ManageFolder,
    CommonFolder,
  },

  data() {
    return {
      showSelectedOptions: false,
      selectedFolderId: null,
      selectedDocument: {},
      trashModal: false,
      trashModalKey: false,
      user: {},
      page: 1,
      totalPages: null,
      totalItensOnPage: 0,
      totalItems: 0,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      downloadList: [],
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      endDate: null,
      documents: [],
      apiService: new ApiService(),
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
        name: '',
      },
      modal: false,
      deleteDialog: false,
      valid: false,
      editMode: false,
      newDocument: {
        name: '',
        file: null,
        institutionId: null,
        expireDate: null,
        fileBase64: '',
      },
      menuExpireDate: false,
      dialogKey: false,
      headerCheckbox: false,
      tab: 0,
      folderModal: false,
      folderDialogKey: Date.now() + 1,
      folder: {
        name: '',
        institutionId: '',
        folderId: null,
      },
      folders: [],
      deleteFolderDialog: false,
      selectedFolder: null,
      editFolderMode: false,
      expanded: [],
      secondExpanded: [],
      thirdExpanded: [],
      singleExpand: true,
      moveFolderModal: false,
      moveFolderDialogKey: Date.now() + 2,
      selectedFolderToMove: null,
      combinedItems: [],
      loadingCombinedTable: false,
      combinedPage: 1,
      combinedPageSize: 10,
      allFolders: [],
      availableFoldersToMove: [],
      listFolderWithDoc: [],
      filterListFolderWithDoc: {
        institutionId: null,
        name: '',
        page: 1,
        pageSize: 10,
      },
      specificFolder: null,
      allFoldersWithoutRemove: [],
      panel: null,
      addMenuItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openFolderModal,
        },
      ],
      addTableItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openAddDocModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openAddFolderModal,
        },
      ],
      addToFolderModal: false,
      addToFolderDialogKey: Date.now() + 3,
      addToDoMode: false,
      allFoldersWithoutOwn: [],
      allFoldersWithoutRemoveAndOwn: [],
      parentFolderId: null,
      commonAreafilesSize: 0,
      institution: {},
    }
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.loadData()
    this.updateSumFiles()
  },

  watch: {
    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getListFolderWithDoc()
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getListFolderWithDoc()
    },
  },

  methods: {
    reloadData() {
      this.loadData()
      this.modal = false
      this.folderModal = false
    },

    toggleSelectedOptions() {
      this.showSelectedOptions = !this.showSelectedOptions
    },

    updateSumFiles() {
      this.$emit('totalFilesUpdate')
    },

    async ChangeOrder(event) {
      if (event.moved) {
        const findItem = event.moved.element
        findItem.order = event.moved.newIndex

        if (findItem.filePath) await this.updateDocOrder(findItem)
        else await this.updateFolderOrder(findItem)
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocumentFolder/change-order', model)
    },

    importToInstitution() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      this.apiService
        .get('StandardCommonAreaDocumentFolder/import/' + institutionId)
        .then((response) => {
          this.loadData()
        })
    },

    async loadData() {
      const myPanel = this.panel
      await this.getAllFolders()
      await this.getListFolderWithDoc()
      this.panel = myPanel
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    addToDownloadList(file) {
      if (file.selected) {
        this.downloadList.push(file)
      } else {
        this.downloadList = this.downloadList.filter((x) => x.id != file.id)
      }

      this.headerCheckbox = this.documents.every((doc) => doc.selected)
    },

    async getZip() {
      if (this.downloadList.length > 25) {
        this.$toast.warning('Máximo de 25 arquivos por vez')
        return
      }
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${
          this.downloadList.length
        } ${this.$t('selecionados')}`
      )
      const ids = this.downloadList.map((x) => x.id)

      try {
        const response = await this.apiService.post(`CommonAreaDocument/zip`, {
          ids,
        })
        const zipData = 'data:application/zip;base64,' + response.content

        const link = document.createElement('a')
        link.href = zipData
        link.setAttribute('download', `arquivos_em_lote.zip`)
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        console.error('Erro ao baixar os arquivos:', error)
        this.$toast.error('Erro ao baixar os arquivos selecionados.')
      }
    },

    getFile(document) {
      if (document.filePath) {
        if (document.filePath.includes('equipacarefix.blob.core')) {
          const url = document.filePath
          window.open(url)
        } else {
          const url =
            process.env.VUE_APP_BASE_URL +
            document.filePath.replace('wwwroot/', '')
          window.open(url)
        }
      } else {
        this.getDocument(document)
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : 'Sem registros'
    },

    saveCreatedAt(date) {
      this.startDate = this.formatDate(this.filter.createdAt)
      this.$refs.menuStartDate.save(date)
    },

    saveExpireDate(date) {
      this.endDate = this.formatDate(this.filter.expireDate)
      this.$refs.menuEndDate.save(date)
    },

    openModal() {
      this.selectedDocument = {}
      this.dialogKey = !this.dialogKey
      this.modal = true
    },

    openAddDocModal(item) {
      this.selectedDocument = {}
      this.selectedFolderId = item ? item.id : null
      this.dialogKey = !this.dialogKey
      this.modal = true
    },

    closeModal() {
      this.modal = false
      this.dialogKey = !this.dialogKey
    },

    async addDocument() {
      if (this.$refs.form.validate()) {
        if (!this.newDocument.file) {
          this.$toast.error('Nenhum arquivo selecionado!')
          return
        }

        this.loading = true
        const reader = new FileReader()
        reader.readAsDataURL(this.newDocument.file)

        reader.onload = () => {
          const extension = this.newDocument.file.name.split('.').pop()
          const base64String = reader.result

          const institutionId = JSON.parse(
            localStorage.getItem('institution')
          ).id

          const documentData = {
            identification: this.newDocument.name,
            folderId: this.newDocument.folderId,
            filePath: base64String,
            extension: extension,
            institutionId: institutionId,
            expireDate: this.newDocument.expireDate,
          }

          this.apiService
            .post('CommonAreaDocument/add', documentData)
            .then(() => {
              this.$toast.success('Documento adicionado com sucesso!')
              this.closeModal()
              this.loadData()
              this.updateSumFiles()
              this.loading = false
            })
            .catch((error) => {
              this.$toast.error('Erro ao adicionar o documento.')
              this.loading = false
            })
        }

        reader.onerror = () => {
          this.$toast.error('Erro ao ler o arquivo.')
          this.loading = false
        }
      }
    },

    async updateDocument() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const documentData = {
          id: this.selectedDocument.id,
          identification: this.newDocument.name,
          folderId: this.newDocument.folderId,
          institutionId: JSON.parse(localStorage.getItem('institution')).id,
          expireDate: this.newDocument.expireDate,
        }

        if (this.newDocument.file) {
          const reader = new FileReader()
          reader.readAsDataURL(this.newDocument.file)

          reader.onload = () => {
            const extension = this.newDocument.file.name.split('.').pop()
            documentData.filePath = reader.result
            documentData.extension = extension

            this.sendUpdateRequest(documentData)
          }

          reader.onerror = () => {
            this.$toast.error('Erro ao ler o arquivo.')
            this.loading = false
          }
        } else {
          documentData.filePath = this.selectedDocument.filePath
          documentData.extension = this.selectedDocument.extension
          this.sendUpdateRequest(documentData)
        }
      }
    },

    sendUpdateRequest(documentData) {
      this.apiService
        .post('CommonAreaDocument/edit', documentData)
        .then(() => {
          this.$toast.success('Documento atualizado com sucesso!')
          this.closeModal()
          this.loadData()
          this.loading = false
        })
        .catch((error) => {
          this.$toast.error('Erro ao atualizar o documento.')
          this.loading = false
        })
    },

    editDocument(item) {
      this.documentDialogKey = !this.documentDialogKey
      this.selectedDocument = { ...item }
      this.documentModal = true
    },

    deleteDocument(item) {
      this.selectedDocument = item
      this.deleteDialog = true
    },

    confirmDelete() {
      const selectedDocumentId = this.selectedDocument.id
      this.apiService
        .delete(`CommonAreaDocument/remove/${selectedDocumentId}`)
        .then(() => {
          this.loadData()
          this.$toast.success('Documento excluído com sucesso!')
          this.deleteDialog = false
        })
        .catch(() => {
          this.$toast.error('Erro ao excluir o documento.')
          this.deleteDialog = false
        })
    },

    async deleteSelectedItens() {
      const ids = this.downloadList.map((file) => file.id)

      if (!ids.length) {
        this.$toast.error('Nenhum item selecionado para exclusão.')
        return
      }

      await this.apiService
        .delete('CommonAreaDocument/delete-selected-files', ids)
        .then((response) => {
          if (response.statusCode === 200) {
            this.downloadList = []
            this.showSelectedOptions = false
            return this.loadData().then(() => {
              this.$toast.success('Itens selecionados excluídos com sucesso!')
            })
          } else {
            this.$toast.error('Erro ao excluir os itens selecionados.')
          }
        })
        .catch((error) => {
          console.error('Erro ao excluir os itens selecionados:', error)
          this.$toast.error('Erro ao excluir os itens selecionados.')
        })
    },

    validateDoc(document) {
      const userSignature = JSON.parse(
        localStorage.getItem('user')
      ).signatureImage
      if (!document.validated) {
        if (userSignature) {
          this.newDocument.file = document
          const documentId = this.newDocument.file.id
          this.apiService
            .post(`CommonAreaDocument/validate/${documentId}`)
            .then(() => {
              this.loadData()
              this.$toast.success('Documento validado com sucesso')
            })
            .catch((error) => {
              this.$toast.error('Erro ao validar o documento.')
            })
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique o cadastro de sua assinatura.'
          )
        }
      } else {
        this.$toast.error('Documento já validado!')
      }
    },

    async getAllFolders(itemId) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      try {
        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/${institutionId}`
        )
        this.allFolders = [...response.content]
        this.allFoldersWithoutRemove = [...response.content]
        if (itemId) {
          this.allFoldersWithoutOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
          this.allFoldersWithoutRemoveAndOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
        }
        this.addOptionRemoveToAllFolders()
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addOptionRemoveToAllFolders() {
      this.allFolders.unshift({
        id: null,
        name: 'Remover das pastas',
      })
      this.allFoldersWithoutOwn.unshift({
        id: null,
        name: 'Remover das pastas',
      })
    },

    async getFolders() {
      try {
        const response = await this.apiService.get(
          'CommonAreaDocumentFolder/list',
          this.filter
        )
        this.folders = response.content.data
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addFolder() {
      if (this.$refs.folderForm.validate()) {
        this.folder.institutionId = JSON.parse(
          localStorage.getItem('institution')
        ).id
        this.apiService
          .post('CommonAreaDocumentFolder/add', this.folder)
          .then(() => {
            this.$toast.success('Pasta criada com sucesso!')
            this.folderModal = false
            this.addToFolderModal = false
            this.loadData()
          })
      }
    },

    openFolderModal() {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.folderModal = true
    },

    openAddFolderModal(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = null
      this.parentFolderId = item ? item.id : null
      this.folderModal = true
    },

    updateFolder(item) {
      this.folderDialogKey = !this.folderDialogKey
      this.selectedFolderId = item.id
      this.editFolderMode = true
      this.folderModal = true
    },

    deleteFolder(item) {
      this.selectedFolder = item
      this.deleteFolderDialog = true
    },

    confirmDeleteFolder() {
      const selectedFolderId = this.selectedFolder.id
      this.apiService
        .delete(`CommonAreaDocumentFolder/${selectedFolderId}`)
        .then(() => {
          this.deleteFolderDialog = false
          this.$toast.success('Pasta excluída com sucesso!')
          this.loadData()
        })
    },

    async getListFolderWithDoc() {
      try {
        const institutionId = JSON.parse(localStorage.getItem('institution')).id
        this.filterListFolderWithDoc.institutionId = institutionId
        this.filterListFolderWithDoc.page = this.page
        this.filterListFolderWithDoc.pageSize = this.pageSize

        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.panel = null
        this.listFolderWithDoc = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
        this.totalItensOnPage = response.content.data.length
      } catch (error) {
        console.error('Erro ao carregar a lista de documentos.', error)
      }
    },
  },
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
}

.topper-espansion {
  background-color: #4c6d97;
  display: flex;
  min-height: 48px;
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px 0 28px;
}
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
.v-sheet-style {
  color: var(--primary-button-font-color) !important;
  height: var(--default-button-height) !important;
  background: var(--primary-button-color) !important;
  border-radius: var(--default-button-border-radius) !important;
  font-family: var(--default-font-family) !important;
  font-weight: var(--default-font-weight) !important;
  font-size: var(--default-font-size) !important;
  line-height: var(--default-line-height) !important;
  letter-spacing: var(--default-letter-spacing) !important;
  text-transform: none;
}
</style>
